import { StoreState, useAppDispatch } from 'store';
import { useCallback } from 'react';
import { headerActions } from 'features/header/redux/header.action';
import { useSelector } from 'react-redux';
import { getPartnerHeaderFeaturesFromLocalStorage } from 'utils/local-storage';
import { GetPartnerHeaderFeaturesResponse } from 'features/header/api/types';

export default function useHeader() {
  const dispatch = useAppDispatch();
  const headerState = useSelector((state: StoreState) => state.header);

  const getPartnerHeaderFeatures = useCallback(() => {
    let cachedFeatures = null;
    try {
      cachedFeatures = getPartnerHeaderFeaturesFromLocalStorage();
    } catch (err) {
      console.warn('Error accessing localStorage:', err);
    }

    if (cachedFeatures) {
      try {
        const parsed: GetPartnerHeaderFeaturesResponse =
          JSON.parse(cachedFeatures);
        if (Array.isArray(parsed)) {
          dispatch(headerActions.getPartnerHeaderFeaturesSuccess(parsed));
        } else {
          console.warn('Invalid cached data structure, fetching from API');
          dispatch(headerActions.getPartnerHeaderFeaturesRequest());
        }
      } catch (e) {
        console.warn('Invalid cache, fetching from API', e);
        dispatch(headerActions.getPartnerHeaderFeaturesRequest());
      }
    } else {
      dispatch(headerActions.getPartnerHeaderFeaturesRequest());
    }
  }, [dispatch]);

  return { headerState, getPartnerHeaderFeatures };
}
